
import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Header } from '../components/Header';
import { VehicleGrid } from '../components/VehicleGrid';
import { AdminLoginForm } from '../components/AdminLoginForm';
import { HeroSection } from '../components/HeroSection';
import { ServicesSection } from '../components/ServicesSection';
import { AboutSection } from '../components/AboutSection';
import { FAQSection } from '../components/FAQSection';
import { ContactSection } from '../components/ContactSection';
import { useVehicles } from '../hooks/useVehicles';
import { useAdminAuth } from '../hooks/useAdminAuth';
import { Card, CardContent } from '@/components/ui/card';
import { AlertCircle } from 'lucide-react';

const Index = () => {
  const [showAdminLogin, setShowAdminLogin] = useState(false);
  const [loadVehicles, setLoadVehicles] = useState(false);
  const { isAdminLoggedIn } = useAdminAuth();
  const navigate = useNavigate();
  
  // Defer vehicles loading to improve initial page load performance
  const { data: vehicles = [], isLoading, error } = useVehicles(loadVehicles);
  
  useEffect(() => {
    // Load vehicles after initial render to avoid blocking critical path
    const timer = setTimeout(() => {
      setLoadVehicles(true);
    }, 100);
    return () => clearTimeout(timer);
  }, []);
  
  console.log('🏠 Index page - vehicles:', vehicles?.length || 0, 'isLoading:', isLoading, 'error:', error);

  const handleAdminClick = () => {
    if (isAdminLoggedIn) {
      // If admin is logged in, go to admin page
      navigate('/admin');
    } else {
      // If not logged in, show login form
      setShowAdminLogin(true);
    }
  };

  const handleLoginSuccess = () => {
    setShowAdminLogin(false);
  };

  // Show login form if requested and user is not logged in
  if (showAdminLogin && !isAdminLoggedIn) {
    console.log('Showing admin login form');
    return <AdminLoginForm onLoginSuccess={handleLoginSuccess} />;
  }

  if (error) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center p-4">
        <Card className="max-w-md w-full">
          <CardContent className="p-6 text-center">
            <div className="w-12 h-12 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-4">
              <AlertCircle className="h-6 w-6 text-red-600" />
            </div>
            <h2 className="text-xl font-bold text-red-600 mb-2">Erreur de chargement</h2>
            <p className="text-gray-600">Impossible de charger les données. Veuillez réessayer plus tard.</p>
          </CardContent>
        </Card>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-50 to-gray-100">
      <Header 
        onAdminClick={handleAdminClick}
        isAdmin={false}
      />
      
      <main>
        <>
          <HeroSection />
          <AboutSection />
          <ServicesSection />
          <section className="py-16 bg-white" data-vehicles id="vehicles">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
              <div className="text-center mb-12">
                <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
                  Nos Véhicules Disponibles
                </h2>
                <p className="text-lg text-gray-600 max-w-2xl mx-auto">
                  Découvrez notre sélection de véhicules industriels d'occasion, 
                  rigoureusement contrôlés et garantis.
                </p>
              </div>
              <VehicleGrid 
                vehicles={loadVehicles ? vehicles : []} 
                isLoading={loadVehicles ? isLoading : false}
              />
            </div>
          </section>
          <FAQSection />
          <ContactSection />
        </>
      </main>
    </div>
  );
};

export default Index;
